//This file is automatically rebuilt by the Cesium build process.
export default "struct czm_depthRangeStruct\n\
{\n\
float near;\n\
float far;\n\
};\n\
";
